import { useSelector } from 'react-redux';

export const selfServeCreditBalancesSelector = (state) => state?.selfServeCreditBalances;

export const selfServeCreditBalanceByDealershipIdSelector = (state, dealershipId) =>
	selfServeCreditBalancesSelector(state)?.byDealershipId?.[dealershipId];

export const useSelfServeCreditBalanceByDealershipIdSelector = (dealershipId) =>
	useSelector((state) => selfServeCreditBalanceByDealershipIdSelector(state, dealershipId));
